<template lang="pug">
v-card.mx-auto.swipe(elevation='0')
  v-slide-group(v-model='indexPreview', show-arrows='' , mandatory v-if="!isSetProfile")
    v-slide-item.mb-2(v-for='(f, index) in files' :key='index' v-slot='{ active, toggle }')
      v-chip.ma-1.elevation-2.py-4(@click:close="removeFile(index)" close @click='toggle, previewFile(index)' :color="active ? 'primary ' : 'white grey--text'")
        v-avatar(left='', :color="!active ? 'secondary primary--text' : 'white primary--text'")
          v-icon(size="16" v-if="f.type === 'image/png' || f.type === 'image/jpg' || f.type === 'image/jpeg'") insert_photo
          v-icon(size="16" v-else-if="f.type === 'application/pdf'") picture_as_pdf
          v-icon(size="16" v-else-if="f.type === 'text/plain'") description
          v-icon(size="16" v-else) description
        | {{f.name}}
  v-btn.left(color="primary", @click="swipePrev()" fab large v-if="!isSetProfile"            )
    v-icon keyboard_arrow_left
  v-btn.right(color="primary", @click="swipeNext()" fab large  v-if="!isSetProfile"         )
    v-icon keyboard_arrow_right
  v-expand-transition
    v-card(:height="isMovil ? 'calc(100vh - 258px)' : 500")
      .background-filter.position-relative(:style="`background-image : url(${imgSRC})`", v-if="imgSRC")
      .box-preview-image(:class="{ 'position-center' : filePreview.type !== 'image/png' && filePreview.type !== 'image/jpg' && filePreview.type !== 'image/jpeg' }")
        v-img.text-end(
          v-if="filePreview.type === 'image/png' || filePreview.type === 'image/jpg' || filePreview.type === 'image/jpeg' && imgSRC" :src="imgSRC",
          height="400"
          contain
        )
        .d-flex.ai-center.jc-center.fd-column(v-else)
          //- iframe(src='https://docs.google.com/viewer?url=https://www.bitesite.ca/Signing%20up%20for%20Amazon%20S3.pdf&embedded=true' style='width:600px; height:500px;' frameborder='0')
          img(src="../../static/img/icons-actividad/pdf.png", width="70", v-if="filePreview.type === 'application/pdf'")
          img(src="../../static/img/icons-actividad/txt.png", width="100", v-else-if="filePreview.type === 'text/plain'")
          img(src="../../static/img/icons-actividad/exe.png", width="100", v-else-if="filePreview.type === 'application/x-msdownload'")
          img(src="../../static/img/icons-actividad/zip.png", width="100", v-else-if="filePreview.type === 'application/x-zip-compressed'")
          img(src="../../static/img/icons-actividad/xls.png", width="100", v-else-if="filePreview.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'")
          img(src="../../static/img/icons-actividad/mp4.png", width="100", v-else-if="filePreview.type === 'video/mp4'")
          img(src="../../static/img/icons-actividad/doc.png", width="100", v-else-if="filePreview.type === 'application/msword' || filePreview.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'")
          img(src="../../static/img/icons-actividad/search.png", width="85", v-else)
          v-icon( color="background" size="100" v-else) insert_drive_file
          small.grey--text.font-weight-700.font-size-15.mt-4 {{filePreview.name}}
          //- v-btn(color="primary" small)
          //-   | Visualizar
</template>
<script>
export default {
  name : 'c_preview_files',
  props: {
    archivos : {
      type   : Array,
      default: []
    },
    isSetProfile : {
      type   : Boolean,
      default: false
    }
  },
  data () {
    return  {
      indexPreview: '',
      filePreview : {},
      imgSRC      : '',
      contentText : '',
      files       : this.archivos
    }
  },
  computed : {
    isMovil () {
      var vm = this
      return vm.$vuetify.breakpoint.smAndDown
    }
  },
  created () {
    var vm = this
    vm.previewFile()
  },
  methods : {
    clearFiles () {
      var vm = this
      vm.files = []
    },
    removeFile (index = 0) {
      var vm = this
      var objFile =  vm.files[index]
      for (var i = 0; i < vm.files.length; i++) {
        var file = vm.files[i];
        if (i === vm.indexPreview) vm.imgSRC = ''
        if (file.name === objFile.name) vm.files.splice(i, 1)
      }
      // if (index === vm.indexPreview) vm.imgSRC = ''
      // vm.files.splice(index, 1)
      vm.$emit('remove', objFile)
      vm.swipePrev()
    },
    previewFile (index = 0) {
      var vm           = this
      if (index !== -1) {
        vm.indexPreview  = index
        var reader       = new FileReader()
        vm.filePreview  = vm.files[vm.indexPreview] || {}
        if (vm.filePreview && vm.filePreview.type === 'image/png' || vm.filePreview.type === 'image/jpg' || vm.filePreview.type === 'image/jpeg') {
          reader.onloadend = () => { vm.imgSRC = reader.result }
          if (vm.filePreview) reader.readAsDataURL(vm.filePreview)
          else vm.imgSRC = ''
        } else {
          vm.imgSRC = ''
        }

        if (vm.filePreview && vm.filePreview.type === 'text/plain') {
          reader.onloadend = () => {
            var contents = reader.result
            var lines = contents.split('\n')
            vm.contentText = lines
          }
          if (vm.filePreview) reader.readAsText(vm.filePreview)
          else vm.contentText = ''
        } else {
          vm.contentText = ''
        }
      }
    },
    swipePrev () {
      var vm = this
      var anterior = vm.indexPreview - 1
      vm.previewFile(anterior >= 0 ? anterior : vm.files.length - 1)
    },
    swipeNext () {
      var vm = this
      var siguiente = vm.indexPreview + 1
      vm.previewFile(siguiente <= vm.files.length - 1 ? siguiente : 0)
    }
  }
}
</script>
<style lang="stylus" scoped>
.swipe
  position relative
  .left
    position: absolute;
    top     : 45%;
    left   : 15px;
    z-index 1
  .right
    position: absolute;
    top     : 45%;
    right   : 15px;
    z-index 1
.position-center
  top 33% !important
</style>



// WEBPACK FOOTER //
// c_preview_files.vue?265a996b